import React, { useState } from "react";
import { resolveImageUrl, DEFAULT_FALLBACK_IMAGE } from "../../utils/imageStorage.js";
import {
  Compass,
  MapPin,
  Award,
  Users,
  HeartHandshake,
  GraduationCap,
  Mail,
  Sparkles,
  Building2,
  Search,
  BookOpen,
  PhoneCall,
  Calendar,
  ChevronRight,
  ShieldCheck
} from "lucide-react";
export const AboutPage = ({ settings, lang, onNavigate, pageData }) => {
  const [selectedDept, setSelectedDept] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const bannerImage = resolveImageUrl(
    pageData?.hero_image || pageData?.photos?.find((p) => p.key === "hero")?.url || "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg"
  );
  const campusImage = resolveImageUrl(
    pageData?.photos?.find((p) => p.key === "campus")?.url || pageData?.photos?.find((p) => p.key === "teachers")?.url || "/assets/images/uploads/madrasah_campus_hero_1790844614157.jpg"
  );
  const teachersList = pageData?.teachers || [];
  const activeTeachers = teachersList.filter((t) => t.is_active !== false);
  const departments = [
    { id: "all", name: "All Faculty", name_bn: "\u09B8\u0995\u09B2 \u09B6\u09BF\u0995\u09CD\u09B7\u0995" },
    { id: "admin", name: "Administration & Hifz", name_bn: "\u09AA\u09CD\u09B0\u09B6\u09BE\u09B8\u09A8 \u0993 \u09A4\u09BE\u09B9\u09AB\u09BF\u099C" },
    { id: "islamic", name: "Islamic Studies & Arabic", name_bn: "\u0987\u09B8\u09B2\u09BE\u09AE\u09BF\u09DF\u09BE\u09A4 \u0993 \u0986\u09B0\u09AC\u09BF" },
    { id: "noorani", name: "Noorani Foundation", name_bn: "\u09A8\u09C2\u09B0\u09BE\u09A8\u09C0 \u09AC\u09BF\u09AD\u09BE\u0997" },
    { id: "general", name: "General Academics", name_bn: "\u09B8\u09BE\u09A7\u09BE\u09B0\u09A3 \u098F\u0995\u09BE\u09A1\u09C7\u09AE\u09BF\u0995" },
    { id: "languages", name: "Languages", name_bn: "\u09AD\u09BE\u09B7\u09BE \u09B6\u09BF\u0995\u09CD\u09B7\u09BE" }
  ];
  const filteredTeachers = activeTeachers.filter((t) => {
    if (selectedDept !== "all") {
      const deptStr = `${t.department} ${t.department_bn}`.toLowerCase();
      if (selectedDept === "admin" && !(deptStr.includes("admin") || deptStr.includes("\u09AA\u09CD\u09B0\u09B6\u09BE\u09B8\u09A8") || deptStr.includes("hifz") || deptStr.includes("\u09AE\u09C1\u09B9\u09A4\u09BE\u09AE\u09BF\u09AE"))) return false;
      if (selectedDept === "islamic" && !(deptStr.includes("islamic") || deptStr.includes("arabic") || deptStr.includes("\u0987\u09B8\u09B2\u09BE\u09AE") || deptStr.includes("\u0986\u09B0\u09AC\u09BF") || deptStr.includes("\u09AE\u09C1\u09B9\u09BE\u09A6\u09CD\u09A6\u09BF\u09B8"))) return false;
      if (selectedDept === "noorani" && !(deptStr.includes("noorani") || deptStr.includes("tajweed") || deptStr.includes("\u09A8\u09C2\u09B0\u09BE\u09A8\u09C0") || deptStr.includes("\u09A4\u09BE\u099C\u09AC\u09C0\u09A6"))) return false;
      if (selectedDept === "general" && !(deptStr.includes("primary") || deptStr.includes("general") || deptStr.includes("math") || deptStr.includes("\u09AA\u09CD\u09B0\u09BE\u09A5\u09AE\u09BF\u0995") || deptStr.includes("\u098F\u0995\u09BE\u09A1\u09C7\u09AE\u09BF\u0995") || deptStr.includes("b.sc"))) return false;
      if (selectedDept === "languages" && !(deptStr.includes("language") || deptStr.includes("farsi") || deptStr.includes("\u09AD\u09BE\u09B7\u09BE") || deptStr.includes("\u09AB\u09BE\u09B0\u09CD\u09B8\u09BF"))) return false;
    }
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      const matchName = t.name?.toLowerCase().includes(query) || t.name_bn?.toLowerCase().includes(query);
      const matchDesig = t.designation?.toLowerCase().includes(query) || t.designation_bn?.toLowerCase().includes(query);
      const matchDept = t.department?.toLowerCase().includes(query) || t.department_bn?.toLowerCase().includes(query);
      const matchQual = t.qualification?.toLowerCase().includes(query) || t.qualification_bn?.toLowerCase().includes(query);
      if (!matchName && !matchDesig && !matchDept && !matchQual) return false;
    }
    return true;
  });
  return <div className="py-10 bg-stone-50 min-h-screen space-y-16">
      {
    /* ------------------------------------------------------------- */
  }
      {
    /* 1. VISIBLE, HIGH-IMPACT HERO BANNER SECTION                   */
  }
      {
    /* ------------------------------------------------------------- */
  }
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-emerald-950/90 via-emerald-950/90 to-slate-950/85 text-white rounded-3xl p-6 sm:p-10 lg:p-12 shadow-xl border border-emerald-950/90 backdrop-blur-md overflow-hidden relative">
          
          {
    /* Subtle decorative background light texture */
  }
          <div className="absolute -right-20 -top-20 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -left-20 -bottom-20 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl pointer-events-none" />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center relative z-10">
            
            {
    /* Left Column: Information & Text */
  }
            <div className="lg:col-span-6 space-y-5">
              <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-emerald-900/80 border border-emerald-600/50 text-amber-300 text-xs font-bold uppercase tracking-wider font-sans shadow-sm">
                <Sparkles className="w-3.5 h-3.5 text-amber-400" />
                <span>{lang === "bn" ? pageData?.title_bn || "\u09AE\u09BE\u09A6\u09CD\u09B0\u09BE\u09B8\u09BE\u09B0 \u09AA\u09B0\u09BF\u099A\u09BF\u09A4\u09BF \u0993 \u0989\u09A6\u09CD\u09A6\u09C7\u09B6\u09CD\u09AF" : pageData?.title || "About Our Institution"}</span>
              </div>

              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold tracking-tight text-white leading-tight">
                {lang === "bn" ? pageData?.subtitle_bn || "\u09AC\u09BE\u09DF\u09A4\u09C1\u09B2 \u09AE\u09C1\u0995\u09BE\u09A6\u09CD\u09A6\u09BE\u09B8 \u09AE\u09A1\u09C7\u09B2 \u09AE\u09BE\u09A6\u09CD\u09B0\u09BE\u09B8\u09BE" : pageData?.subtitle || "Baitul Muqaddas Model Madrasah"}
              </h1>

              <div className="text-amber-200 font-serif text-sm sm:text-base italic border-l-2 border-amber-400/80 pl-3 py-0.5">
                {settings.bismillah_header || "\u0628\u0650\u0633\u0652\u0645\u0650 \u0627\u0644\u0644\u064E\u0651\u0647\u0650 \u0627\u0644\u0631\u064E\u0651\u062D\u0652\u0645\u064E\u0670\u0646\u0650 \u0627\u0644\u0631\u064E\u0651\u062D\u0650\u064A\u0645\u0650"}
              </div>

              <p className="text-sm sm:text-base text-emerald-100/90 leading-relaxed font-sans">
                {lang === "bn" ? pageData?.content_bn || "\u09AB\u09C7\u09A8\u09C0 \u099C\u09C7\u09B2\u09BE\u09B0 \u09A6\u09BE\u0997\u09A8\u09AD\u09C2\u099E\u09BE \u0989\u09AA\u099C\u09C7\u09B2\u09BE\u09B0 \u09A4\u09C1\u09B2\u09BE\u09A4\u09B2\u09C0 \u09AC\u09BE\u099C\u09BE\u09B0 \u09B8\u0982\u09B2\u0997\u09CD\u09A8 \u09B6\u09BE\u09A8\u09CD\u09A4 \u09B8\u09AC\u09C1\u099C \u09AA\u09B0\u09BF\u09AC\u09C7\u09B6\u09C7 \u0995\u09C1\u09B0\u0986\u09A8 \u0993 \u09B8\u09C1\u09A8\u09CD\u09A8\u09BE\u09B9\u09B0 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u098F\u09AC\u0982 \u0986\u09A7\u09C1\u09A8\u09BF\u0995 \u09AC\u09BF\u09B6\u09CD\u09AC\u09C7\u09B0 \u099A\u09BE\u09B9\u09BF\u09A6\u09BE\u0995\u09C7 \u09B8\u09BE\u09AE\u09A8\u09C7 \u09B0\u09C7\u0996\u09C7 \u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BF\u09A4 \u098F\u0995\u099F\u09BF \u09AF\u09C1\u0997\u09BE\u09A8\u09CD\u09A4\u0995\u09BE\u09B0\u09C0 \u0986\u09A6\u09B0\u09CD\u09B6 \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BE\u09A8\u0964" : pageData?.content || "Founded beside Tulatoli Bazar, Daganbhuiyan, Feni, with the sacred objective of integrating deep Quranic wisdom with high-standard contemporary school education."}
              </p>

              {
    /* Quick stats pills */
  }
              <div className="pt-2 flex flex-wrap items-center gap-3 text-xs">
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-emerald-900/60 border border-emerald-700/60 text-emerald-100">
                  <MapPin className="w-4 h-4 text-amber-400 shrink-0" />
                  <span>{lang === "bn" ? settings.address_bn : settings.address}</span>
                </div>
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-emerald-900/60 border border-emerald-700/60 text-emerald-100">
                  <Users className="w-4 h-4 text-amber-400 shrink-0" />
                  <span>{activeTeachers.length} {lang === "bn" ? "\u099C\u09A8 \u0985\u09AD\u09BF\u099C\u09CD\u099E \u09B6\u09BF\u0995\u09CD\u09B7\u0995" : "Scholarly Faculty"}</span>
                </div>
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-emerald-900/60 border border-emerald-700/60 text-emerald-100">
                  <Calendar className="w-4 h-4 text-amber-400 shrink-0" />
                  <span>{lang === "bn" ? "\u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BF\u09A4" : "Est."} {settings.established_year || "\u09E8\u09E6\u09E8\u09EA"}</span>
                </div>
              </div>
            </div>

            {
    /* Right Column: Featured Crystal-Clear Banner Image */
  }
            <div className="lg:col-span-6">
              <div className="relative rounded-2xl overflow-hidden border-2 border-emerald-700/60 shadow-2xl bg-emerald-950 group">
                <img
    src={bannerImage}
    alt={lang === "bn" ? "\u09AC\u09BE\u09DF\u09A4\u09C1\u09B2 \u09AE\u09C1\u0995\u09BE\u09A6\u09CD\u09A6\u09BE\u09B8 \u09AE\u09A1\u09C7\u09B2 \u09AE\u09BE\u09A6\u09CD\u09B0\u09BE\u09B8\u09BE \u09AC\u09CD\u09AF\u09BE\u09A8\u09BE\u09B0" : "Baitul Muqaddas Model Madrasah Banner"}
    className="w-full h-72 sm:h-84 lg:h-96 object-cover group-hover:scale-103 transition-transform duration-500"
    referrerPolicy="no-referrer"
    onError={(e) => {
      if (e.currentTarget.dataset.failed) return;
      e.currentTarget.dataset.failed = "true";
      e.currentTarget.src = DEFAULT_FALLBACK_IMAGE;
    }}
  />
                
                {
    /* Image Overlay Badge & Caption */
  }
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent p-4 sm:p-5 text-white flex flex-col justify-end">
                  <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-amber-500/90 text-emerald-950 font-bold text-[11px] uppercase tracking-wider w-fit mb-1.5">
                    <Building2 className="w-3.5 h-3.5" />
                    <span>{lang === "bn" ? "\u0985\u09AB\u09BF\u09B8\u09BF\u09DF\u09BE\u09B2 \u09AC\u09CD\u09AF\u09BE\u09A8\u09BE\u09B0 \u0993 \u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8" : "Official Campus Banner"}</span>
                  </div>
                  <h3 className="text-sm sm:text-base font-bold text-white leading-snug">
                    {lang === "bn" ? settings.site_name_bn : settings.site_name}
                  </h3>
                  <p className="text-xs text-emerald-200 mt-0.5">
                    {lang === "bn" ? settings.address_bn : settings.address}
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {
    /* ------------------------------------------------------------- */
  }
      {
    /* 2. DYNAMIC TEACHER & FACULTY PROFILES SECTION                 */
  }
      {
    /* ------------------------------------------------------------- */
  }
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-6 sm:p-10 lg:p-12 rounded-3xl border border-stone-200 shadow-sm space-y-8">
          
          {
    /* Section Header */
  }
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 border-b border-stone-200 pb-8">
            <div className="space-y-2 max-w-2xl">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-amber-100 text-amber-900 text-xs font-bold uppercase tracking-wider">
                <GraduationCap className="w-4 h-4 text-amber-700" />
                <span>{lang === "bn" ? "\u0986\u09AE\u09BE\u09A6\u09C7\u09B0 \u09B6\u09BF\u0995\u09CD\u09B7\u0995\u09AE\u09A3\u09CD\u09A1\u09B2\u09C0" : "Our Scholarly Faculty"}</span>
              </div>
              <h2 className="text-2xl sm:text-4xl font-serif font-bold text-slate-900 tracking-tight">
                {lang === "bn" ? "\u0985\u09AD\u09BF\u099C\u09CD\u099E \u09B6\u09BF\u0995\u09CD\u09B7\u0995 \u0993 \u09AA\u09B0\u09BF\u099A\u09BE\u09B2\u09A8\u09BE \u09AA\u09B0\u09CD\u09B7\u09A6\u09C7\u09B0 \u09AA\u09CD\u09B0\u09CB\u09AB\u09BE\u0987\u09B2" : "Distinguished Teachers & Academic Mentors"}
              </h2>
              <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
                {lang === "bn" ? "\u0986\u09A8\u09CD\u09A4\u09B0\u09CD\u099C\u09BE\u09A4\u09BF\u0995 \u09AE\u09BE\u09A8\u09C7\u09B0 \u09B9\u09BE\u09AB\u09C7\u099C\u09C7 \u0995\u09C1\u09B0\u0986\u09A8, \u09A6\u09BE\u0993\u09B0\u09BE\u09AF\u09BC\u09C7 \u09B9\u09BE\u09A6\u09BF\u09B8 \u0989\u09A4\u09CD\u09A4\u09C0\u09B0\u09CD\u09A3 \u09AC\u09BF\u099C\u09CD\u099E \u0986\u09B2\u09C7\u09AE, \u09AE\u09C1\u09AB\u09A4\u09BF \u098F\u09AC\u0982 \u09AC\u09BF\u098F\u09B8\u09B8\u09BF \u09A1\u09BF\u0997\u09CD\u09B0\u09BF\u09A7\u09BE\u09B0\u09C0 \u09A8\u09BF\u09AC\u09C7\u09A6\u09BF\u09A4\u09AA\u09CD\u09B0\u09BE\u09A3 \u09B6\u09BF\u0995\u09CD\u09B7\u0995\u09AE\u09A3\u09CD\u09A1\u09B2\u09C0\u09B0 \u09B8\u09B0\u09BE\u09B8\u09B0\u09BF \u09A4\u09A4\u09CD\u09A4\u09CD\u09AC\u09BE\u09AC\u09A7\u09BE\u09A8\u0964" : "Meet the certified Islamic scholars, master trainers, and experienced academic instructors guiding our students with care and sincerity."}
              </p>
            </div>

            {
    /* Quick Stats Counter */
  }
            <div className="flex items-center gap-3">
              <div className="px-4 py-2 rounded-2xl bg-emerald-50 border border-emerald-200 text-emerald-900 flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-emerald-700" />
                <div>
                  <div className="text-xs font-bold font-mono">{activeTeachers.length} {lang === "bn" ? "\u099C\u09A8 \u09B6\u09BF\u0995\u09CD\u09B7\u0995" : "Faculty Members"}</div>
                  <div className="text-[10px] text-emerald-700">{lang === "bn" ? "\u09A8\u09BF\u09DF\u09AE\u09BF\u09A4 \u09AA\u09BE\u09A0\u09A6\u09BE\u09A8\u09C7 \u09B8\u0995\u09CD\u09B0\u09BF\u09DF" : "Active & Certified"}</div>
                </div>
              </div>
            </div>
          </div>

          {
    /* Department Filter Pills and Search Bar */
  }
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            
            {
    /* Department Pills */
  }
            <div className="flex flex-wrap gap-2">
              {departments.map((dept) => {
    const isSelected = selectedDept === dept.id;
    return <button
      key={dept.id}
      onClick={() => setSelectedDept(dept.id)}
      className={`px-3.5 py-2 rounded-xl text-xs font-semibold transition-all cursor-pointer ${isSelected ? "bg-emerald-950 text-white shadow-sm ring-2 ring-emerald-800" : "bg-stone-100 text-slate-700 hover:bg-stone-200"}`}
    >
                    {lang === "bn" ? dept.name_bn : dept.name}
                  </button>;
  })}
            </div>

            {
    /* Search Input */
  }
            <div className="relative min-w-[240px] sm:w-72">
              <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input
    type="text"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    placeholder={lang === "bn" ? "\u09B6\u09BF\u0995\u09CD\u09B7\u0995 \u09AC\u09BE \u09AC\u09BF\u09B7\u09DF \u0996\u09C1\u0981\u099C\u09C1\u09A8..." : "Search teacher or subject..."}
    className="w-full pl-9 pr-4 py-2 text-xs rounded-xl border border-stone-300 bg-stone-50 focus:bg-white focus:outline-hidden focus:ring-1 focus:ring-emerald-700"
  />
              {searchQuery && <button
    onClick={() => setSearchQuery("")}
    className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400 hover:text-slate-600 cursor-pointer"
  >
                  ✕
                </button>}
            </div>
          </div>

          {
    /* Teachers Cards Grid */
  }
          {filteredTeachers.length === 0 ? <div className="text-center py-12 bg-stone-50 rounded-2xl border border-dashed border-stone-300 space-y-2">
              <Users className="w-8 h-8 text-slate-400 mx-auto" />
              <p className="text-xs font-semibold text-slate-600">
                {lang === "bn" ? "\u0995\u09CB\u09A8 \u09B6\u09BF\u0995\u09CD\u09B7\u0995 \u09AA\u09BE\u0993\u09DF\u09BE \u09AF\u09BE\u09DF\u09A8\u09BF" : "No faculty members match your filter"}
              </p>
              <button
    onClick={() => {
      setSelectedDept("all");
      setSearchQuery("");
    }}
    className="text-xs text-emerald-800 font-bold underline cursor-pointer"
  >
                {lang === "bn" ? "\u09B8\u0995\u09B2 \u09B6\u09BF\u0995\u09CD\u09B7\u0995 \u09AA\u09CD\u09B0\u09A6\u09B0\u09CD\u09B6\u09A8 \u0995\u09B0\u09C1\u09A8" : "Show all teachers"}
              </button>
            </div> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredTeachers.map((teacher) => <div
    key={teacher.id}
    className="bg-stone-50 rounded-2xl border border-stone-200 p-5 hover:border-emerald-700 hover:shadow-md transition-all duration-300 flex flex-col justify-between group"
  >
                  <div className="space-y-4">
                    
                    {
    /* Top: Avatar & Department / Name */
  }
                    <div className="flex items-start gap-4">
                      <div className="w-20 h-20 rounded-2xl overflow-hidden bg-emerald-950 shrink-0 border-2 border-white shadow-md relative group-hover:scale-105 transition-transform duration-300">
                        <img
    src={resolveImageUrl(teacher.photo)}
    alt={teacher.name}
    className="w-full h-full object-cover"
    referrerPolicy="no-referrer"
    onError={(e) => {
      if (e.currentTarget.dataset.failed) return;
      e.currentTarget.dataset.failed = "true";
      e.currentTarget.src = DEFAULT_FALLBACK_IMAGE;
    }}
  />
                      </div>

                      <div className="flex-1 min-w-0">
                        <span className="inline-block px-2.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-emerald-100 text-emerald-900 border border-emerald-200/80 mb-1 truncate max-w-full">
                          {lang === "bn" ? teacher.department_bn : teacher.department}
                        </span>
                        
                        <h3 className="text-base font-bold text-slate-900 leading-snug group-hover:text-emerald-800 transition-colors">
                          {lang === "bn" ? teacher.name_bn : teacher.name}
                        </h3>

                        <p className="text-xs font-semibold text-amber-700 mt-0.5">
                          {lang === "bn" ? teacher.designation_bn : teacher.designation}
                        </p>

                        {
    /* Secondary language name if different */
  }
                        <p className="text-[11px] text-slate-400 font-normal truncate mt-0.5">
                          {lang === "bn" ? teacher.name : teacher.name_bn}
                        </p>
                      </div>
                    </div>

                    {
    /* Academic Qualification & Sanad */
  }
                    <div className="space-y-2 pt-2 border-t border-stone-200 text-xs">
                      <div className="bg-white p-3 rounded-xl border border-stone-200/90 shadow-2xs">
                        <div className="flex items-center gap-1.5 text-[10px] font-bold text-slate-400 uppercase">
                          <BookOpen className="w-3.5 h-3.5 text-amber-600" />
                          <span>{lang === "bn" ? "\u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u0997\u09A4 \u09AF\u09CB\u0997\u09CD\u09AF\u09A4\u09BE \u0993 \u09B8\u09A8\u09A6" : "Academic Credentials"}</span>
                        </div>
                        <p className="text-slate-800 font-semibold mt-1">
                          {lang === "bn" ? teacher.qualification_bn : teacher.qualification}
                        </p>
                      </div>

                      {
    /* Bio summary */
  }
                      {(teacher.bio || teacher.bio_bn) && <p className="text-slate-600 text-[11px] leading-relaxed line-clamp-3 italic bg-white/60 p-2.5 rounded-lg border border-stone-200/60">
                          "{lang === "bn" ? teacher.bio_bn || teacher.bio : teacher.bio || teacher.bio_bn}"
                        </p>}
                    </div>
                  </div>

                  {
    /* Bottom Contacts & Actions */
  }
                  <div className="pt-3 mt-3 border-t border-stone-200 flex items-center justify-between text-xs">
                    {teacher.phone ? <a
    href={`tel:${teacher.phone.replace(/[^0-9+]/g, "")}`}
    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-800 font-semibold text-[11px] transition-colors"
  >
                        <PhoneCall className="w-3.5 h-3.5 text-emerald-700" />
                        <span>{teacher.phone}</span>
                      </a> : <span className="text-[11px] text-slate-400 font-mono">BMM Faculty</span>}

                    {teacher.email && <a
    href={`mailto:${teacher.email}`}
    className="text-slate-500 hover:text-emerald-800 p-1.5 rounded-lg hover:bg-stone-200 transition-colors"
    title={teacher.email}
  >
                        <Mail className="w-4 h-4" />
                      </a>}
                  </div>
                </div>)}
            </div>}

          {
    /* Bottom Note on Faculty Standards */
  }
          <div className="p-4 rounded-2xl bg-amber-50/80 border border-amber-200 text-amber-900 text-xs flex items-center gap-3">
            <Sparkles className="w-5 h-5 text-amber-700 shrink-0" />
            <p>
              {lang === "bn" ? "\u09B8\u0995\u09B2 \u09B6\u09BF\u0995\u09CD\u09B7\u0995 \u09A8\u09BF\u09DF\u09AE\u09BF\u09A4 \u0985\u09AD\u09CD\u09AF\u09A8\u09CD\u09A4\u09B0\u09C0\u09A3 \u09B6\u09BF\u0995\u09CD\u09B7\u0995 \u09AA\u09CD\u09B0\u09B6\u09BF\u0995\u09CD\u09B7\u09A3 \u0995\u09B0\u09CD\u09AE\u09B6\u09BE\u09B2\u09BE \u098F\u09AC\u0982 \u09B6\u09BF\u0995\u09CD\u09B7\u09A3\u09AA\u09A6\u09CD\u09A7\u09A4\u09BF \u09AC\u09BF\u09B7\u09DF\u0995 \u09B8\u09C7\u09AE\u09BF\u09A8\u09BE\u09B0\u09C7 \u0985\u0982\u09B6\u0997\u09CD\u09B0\u09B9\u09A3 \u0995\u09B0\u09C7\u09A8\u0964" : "All faculty members undergo regular pedagogical development and continuous Islamic tarbiyah workshops."}
            </p>
          </div>

        </div>
      </section>

      {
    /* ------------------------------------------------------------- */
  }
      {
    /* 3. CAMPUS BACKGROUND & HISTORY SECTION                        */
  }
      {
    /* ------------------------------------------------------------- */
  }
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          
          <div className="lg:col-span-6 space-y-5">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-100 text-emerald-900 text-xs font-bold uppercase tracking-wider">
              <Compass className="w-3.5 h-3.5 text-emerald-800" />
              <span>{lang === "bn" ? "\u0986\u09AE\u09BE\u09A6\u09C7\u09B0 \u0987\u09A4\u09BF\u09B9\u09BE\u09B8 \u0993 \u09B2\u0995\u09CD\u09B7\u09CD\u09AF" : "Our Background & Vision"}</span>
            </div>

            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate-900 tracking-tight text-balance leading-snug">
              {lang === "bn" ? "\u09A6\u09CD\u09AC\u09C0\u09A8 \u0993 \u09A6\u09C1\u09A8\u09BF\u09DF\u09BE\u09B0 \u09B8\u09C1\u09B7\u09AE \u09AE\u09C7\u09B2\u09AC\u09A8\u09CD\u09A7\u09A8\u09C7 \u098F\u0995 \u09A8\u09A4\u09C1\u09A8 \u09A6\u09BF\u0997\u09A8\u09CD\u09A4" : "Bridging Sacred Islamic Tradition and Contemporary Schooling"}
            </h2>

            <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
              {lang === "bn" ? "\u09AC\u09B0\u09CD\u09A4\u09AE\u09BE\u09A8\u09C7 \u0985\u09A7\u09BF\u0995\u09BE\u0982\u09B6 \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BE\u09A8\u09C7 \u09A6\u09CD\u09AC\u09C0\u09A8\u09BF \u09B6\u09BF\u0995\u09CD\u09B7\u09BE \u098F\u09AC\u0982 \u0986\u09A7\u09C1\u09A8\u09BF\u0995 \u09B8\u09BE\u09A7\u09BE\u09B0\u09A3 \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u09B0 \u09AE\u09BE\u099D\u09C7 \u098F\u0995 \u09AC\u09BF\u09B0\u09BE\u099F \u09A6\u09C2\u09B0\u09A4\u09CD\u09AC \u09AA\u09B0\u09BF\u09B2\u0995\u09CD\u09B7\u09BF\u09A4 \u09B9\u09DF\u0964 \u09B8\u09BE\u09A7\u09BE\u09B0\u09A3 \u09B8\u09CD\u0995\u09C1\u09B2\u09C7\u09B0 \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u09B0\u09CD\u09A5\u09C0\u09B0\u09BE \u0995\u09C1\u09B0\u0986\u09A8\u09C7\u09B0 \u09AC\u09BF\u09B6\u09C1\u09A6\u09CD\u09A7 \u09A4\u09C7\u09B2\u09BE\u0993\u09AF\u09BC\u09BE\u09A4 \u0993 \u0987\u09B8\u09B2\u09BE\u09AE\u09BF \u09AE\u09C2\u09B2\u09CD\u09AF\u09AC\u09CB\u09A7 \u09A5\u09C7\u0995\u09C7 \u09AC\u099E\u09CD\u099A\u09BF\u09A4 \u09A5\u09BE\u0995\u09C7, \u0986\u09AC\u09BE\u09B0 \u0985\u09A8\u09C7\u0995 \u09B8\u09A8\u09BE\u09A4\u09A8 \u09AE\u09BE\u09A6\u09CD\u09B0\u09BE\u09B8\u09BE\u09B0 \u099B\u09BE\u09A4\u09CD\u09B0\u09B0\u09BE \u0986\u09A7\u09C1\u09A8\u09BF\u0995 \u0987\u0982\u09B0\u09C7\u099C\u09BF, \u0997\u09A3\u09BF\u09A4 \u0993 \u09AC\u09BF\u099C\u09CD\u099E\u09BE\u09A8\u09C7 \u09AA\u09BF\u099B\u09BF\u09DF\u09C7 \u09AA\u09DC\u09C7\u0964" : "In many contemporary educational systems, a deep dichotomy exists between religious studies and modern academics. Baitul Muqaddas Model Madrasah was established to eliminate this divide."}
            </p>

            <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
              {lang === "bn" ? "\u098F\u0987 \u09AC\u09BE\u09B8\u09CD\u09A4\u09AC\u09A4\u09BE\u0995\u09C7 \u0989\u09AA\u09B2\u09AC\u09CD\u09A7\u09BF \u0995\u09B0\u09C7 \u09AB\u09C7\u09A8\u09C0\u09B0 \u09A6\u09BE\u0997\u09A8\u09AD\u09C2\u099E\u09BE\u09B0 \u09A4\u09C1\u09B2\u09BE\u09A4\u09B2\u09C0 \u09AC\u09BE\u099C\u09BE\u09B0 \u09B8\u0982\u09B2\u0997\u09CD\u09A8 \u09B8\u09CD\u09A5\u09BE\u09A8\u09C7 \u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BF\u09A4 \u09B9\u09DF\u09C7\u099B\u09C7 \u09AC\u09BE\u09AF\u09BC\u09A4\u09C1\u09B2 \u09AE\u09C1\u0995\u09BE\u09A6\u09CD\u09A6\u09BE\u09B8 \u09AE\u09A1\u09C7\u09B2 \u09AE\u09BE\u09A6\u09CD\u09B0\u09BE\u09B8\u09BE\u0964 \u098F\u0996\u09BE\u09A8\u09C7 \u098F\u0995\u0987 \u099B\u09BE\u09A6\u09C7\u09B0 \u09A8\u09BF\u099A\u09C7 \u09B6\u09BF\u0995\u09CD\u09B7\u09BE\u09B0\u09CD\u09A5\u09C0 \u09A8\u09C2\u09B0\u09BE\u09A8\u09C0 \u09AA\u09A6\u09CD\u09A7\u09A4\u09BF\u09A4\u09C7 \u0995\u09CB\u09B0\u0986\u09A8 \u09B9\u09BF\u09AB\u099C \u0995\u09B0\u09BE\u09B0 \u09AA\u09BE\u09B6\u09BE\u09AA\u09BE\u09B6\u09BF \u09AA\u09CD\u09B0\u09A5\u09AE \u09B6\u09CD\u09B0\u09C7\u09A3\u09BF \u09A5\u09C7\u0995\u09C7 \u09AA\u099E\u09CD\u099A\u09AE \u09B6\u09CD\u09B0\u09C7\u09A3\u09BF \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09B8\u09BE\u09A7\u09BE\u09B0\u09A3 \u09AA\u09BE\u09A0\u09CD\u09AF\u0995\u09CD\u09B0\u09AE\u09C7 \u09AA\u09C2\u09B0\u09CD\u09A3 \u09AA\u09BE\u09B0\u09A6\u09B0\u09CD\u09B6\u09BF\u09A4\u09BE \u0985\u09B0\u09CD\u099C\u09A8 \u0995\u09B0\u09C7\u0964" : "Under one harmonious roof, our students memorize the Holy Quran with authentic Tajweed while simultaneously mastering NCTB general school subjects: Bangla, English, Mathematics, Science, and foreign languages (Arabic and Persian)."}
            </p>

            <div className="pt-2 flex items-center gap-4">
              <button
    onClick={() => onNavigate("curriculum")}
    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-emerald-900 hover:bg-emerald-950 text-white text-xs font-bold transition-all shadow-xs cursor-pointer"
  >
                <span>{lang === "bn" ? "\u0986\u09AE\u09BE\u09A6\u09C7\u09B0 \u09AA\u09BE\u09A0\u09CD\u09AF\u0995\u09CD\u09B0\u09AE \u09A6\u09C7\u0996\u09C1\u09A8" : "View Full Curriculum"}</span>
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>

          <div className="lg:col-span-6 rounded-3xl overflow-hidden border border-stone-200 shadow-lg relative group bg-emerald-950">
            <img
    src={campusImage}
    alt="Faculty and campus grounds"
    className="w-full h-80 sm:h-96 object-cover group-hover:scale-102 transition-transform duration-500"
    referrerPolicy="no-referrer"
    onError={(e) => {
      if (e.currentTarget.dataset.failed) return;
      e.currentTarget.dataset.failed = "true";
      e.currentTarget.src = DEFAULT_FALLBACK_IMAGE;
    }}
  />
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent p-5 text-white">
              <span className="font-bold text-xs text-amber-300 block">বায়তুল মুকাদ্দাস মডেল মাদ্রাসা ক্যাম্পাস প্রাঙ্গণ</span>
              <span className="text-xs text-white/90">তুলাতলী বাজার সংলগ্ন, দাগনভূঞা, ফেনী</span>
            </div>
          </div>

        </div>
      </div>

      {
    /* ------------------------------------------------------------- */
  }
      {
    /* 4. MISSION, VISION & CORE VALUES                              */
  }
      {
    /* ------------------------------------------------------------- */
  }
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white p-8 rounded-3xl border border-stone-200 shadow-xs space-y-3">
            <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-800 flex items-center justify-center font-bold">
              <Compass className="w-5 h-5" />
            </div>
            <h3 className="font-serif font-bold text-lg text-slate-900">
              {lang === "bn" ? "\u0986\u09AE\u09BE\u09A6\u09C7\u09B0 \u09AD\u09BF\u09B6\u09A8 (Vision)" : "Our Vision"}
            </h3>
            <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
              {lang === "bn" ? "\u098F\u09AE\u09A8 \u098F\u0995 \u09AA\u09CD\u09B0\u099C\u09A8\u09CD\u09AE \u0997\u09DC\u09C7 \u09A4\u09CB\u09B2\u09BE \u09AF\u09BE\u09B0\u09BE \u0995\u09C1\u09B0\u0986\u09A8\u09BF \u0986\u09A6\u09B0\u09CD\u09B6\u09C7 \u099A\u09B0\u09BF\u09A4\u09CD\u09B0\u09AC\u09BE\u09A8, \u09A6\u09CD\u09AC\u09C0\u09A8\u09BF \u099C\u09CD\u099E\u09BE\u09A8\u09C7 \u09B8\u09AE\u09C3\u09A6\u09CD\u09A7 \u098F\u09AC\u0982 \u0986\u09A7\u09C1\u09A8\u09BF\u0995 \u099C\u09CD\u099E\u09BE\u09A8-\u09AC\u09BF\u099C\u09CD\u099E\u09BE\u09A8 \u0993 \u09AD\u09BE\u09B7\u09BE \u09A6\u0995\u09CD\u09B7\u09A4\u09BE\u09DF \u09AC\u09BF\u09B6\u09CD\u09AC\u09C7\u09B0 \u09AF\u09C7 \u0995\u09CB\u09A8\u09CB \u09AA\u09CD\u09B0\u09A4\u09BF\u09AF\u09CB\u0997\u09BF\u09A4\u09BE\u09DF \u09B8\u09AB\u09B2\u0964" : "To raise a pious, enlightened generation rooted in prophetic values, proficient in sciences and global languages, capable of serving humanity."}
            </p>
          </div>

          <div className="bg-white p-8 rounded-3xl border border-stone-200 shadow-xs space-y-3">
            <div className="w-10 h-10 rounded-xl bg-amber-100 text-amber-800 flex items-center justify-center font-bold">
              <Award className="w-5 h-5" />
            </div>
            <h3 className="font-serif font-bold text-lg text-slate-900">
              {lang === "bn" ? "\u0986\u09AE\u09BE\u09A6\u09C7\u09B0 \u09AE\u09BF\u09B6\u09A8 (Mission)" : "Our Mission"}
            </h3>
            <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
              {lang === "bn" ? "\u09B8\u09CD\u09A8\u09C7\u09B9\u09AA\u09C2\u09B0\u09CD\u09A3 \u09AA\u09B0\u09BF\u09AC\u09C7\u09B6\u09C7 \u09AA\u09CD\u09B0\u09A4\u09BF\u099F\u09BF \u09B6\u09BF\u09B6\u09C1\u09B0 \u09AE\u09C7\u09A7\u09BE \u0993 \u09B0\u09C1\u099A\u09BF\u0995\u09C7 \u09B8\u09AE\u09CD\u09AE\u09BE\u09A8 \u099C\u09BE\u09A8\u09BF\u09DF\u09C7 \u09B8\u09B9\u09C0\u09B9 \u09A4\u09BE\u099C\u09AC\u09C0\u09A6\u09C7 \u0995\u09C1\u09B0\u0986\u09A8 \u09B6\u09BF\u0995\u09CD\u09B7\u09BE, \u09B8\u09C1\u09A8\u09CD\u09A6\u09B0 \u09B9\u09B8\u09CD\u09A4\u09B2\u09BF\u09AA\u09BF, \u09A8\u09C8\u09A4\u09BF\u0995 \u099A\u09B0\u09BF\u09A4\u09CD\u09B0 \u0997\u09A0\u09A8 \u098F\u09AC\u0982 \u09AC\u09BF\u09B7\u09DF\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u0995 \u09B8\u09CD\u09AA\u09B7\u09CD\u099F \u09AA\u09BE\u09A0\u09A6\u09BE\u09A8\u0964" : "Delivering holistic, student-centered education through certified scholars, nurturing cursive handwriting and Arabic calligraphy, with rigorous academic monitoring."}
            </p>
          </div>

          <div className="bg-white p-8 rounded-3xl border border-stone-200 shadow-xs space-y-3">
            <div className="w-10 h-10 rounded-xl bg-teal-100 text-teal-800 flex items-center justify-center font-bold">
              <HeartHandshake className="w-5 h-5" />
            </div>
            <h3 className="font-serif font-bold text-lg text-slate-900">
              {lang === "bn" ? "\u09AE\u09C2\u09B2 \u09AE\u09C2\u09B2\u09CD\u09AF\u09AC\u09CB\u09A7 (Core Values)" : "Core Values"}
            </h3>
            <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
              {lang === "bn" ? "\u0987\u0996\u09B2\u09BE\u09B8 (\u098F\u0995\u09A8\u09BF\u09B7\u09CD\u09A0\u09A4\u09BE), \u0986\u09A6\u09AC (\u09B6\u09C3\u0999\u09CD\u0996\u09B2\u09BE \u0993 \u09B8\u09AE\u09CD\u09AE\u09BE\u09A8), \u0986\u09AE\u09BE\u09A8\u09A4\u09A6\u09BE\u09B0\u09BF\u09A4\u09BE, \u09AA\u09BF\u09A4\u09BE-\u09AE\u09BE\u09A4\u09BE \u0993 \u09B6\u09BF\u0995\u09CD\u09B7\u0995\u09A6\u09C7\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u09BF\u09A8\u09DF \u098F\u09AC\u0982 \u09B8\u09A4\u09A4\u09BE\u09B0 \u09AC\u09BE\u09B8\u09CD\u09A4\u09AC \u0985\u09A8\u09C1\u09B6\u09C0\u09B2\u09A8\u0964" : "Sincerity (Ikhlas), Discipline (Adab), Trustworthiness (Amanah), Respect for parents and elders, and relentless dedication to truth."}
            </p>
          </div>
        </div>
      </div>

      {
    /* ------------------------------------------------------------- */
  }
      {
    /* 5. CAMPUS INFRASTRUCTURE & FACILITIES                         */
  }
      {
    /* ------------------------------------------------------------- */
  }
      <div className="bg-white py-16 border-y border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto mb-12 space-y-2">
            <span className="text-emerald-800 font-bold text-xs uppercase tracking-wider block">
              {lang === "bn" ? "\u0989\u09A8\u09CD\u09A8\u09A4 \u0985\u09AC\u0995\u09BE\u09A0\u09BE\u09AE\u09CB" : "Modern Infrastructure"}
            </span>
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate-900">
              {lang === "bn" ? "\u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8\u09C7\u09B0 \u09B8\u09C1\u09AF\u09CB\u0997-\u09B8\u09C1\u09AC\u09BF\u09A7\u09BE\u09B8\u09AE\u09C2\u09B9" : "Campus Facilities & Environment"}
            </h2>
            <p className="text-xs sm:text-sm text-slate-600">
              {lang === "bn" ? "\u09B6\u09BF\u09B6\u09C1\u09B0 \u09B6\u09BE\u09B0\u09C0\u09B0\u09BF\u0995 \u09B8\u09C1\u09B8\u09CD\u09A5\u09A4\u09BE \u0993 \u09AE\u09BE\u09A8\u09B8\u09BF\u0995 \u09AA\u09CD\u09B0\u09AB\u09C1\u09B2\u09CD\u09B2\u09A4\u09BE \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09AA\u09B0\u09BF\u0995\u09B2\u09CD\u09AA\u09BF\u09A4 \u09AE\u09A8\u09CB\u09B0\u09AE \u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8" : "Thoughtfully designed spaces ensuring comfort, safety, and spiritual tranquility"}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200/80 space-y-2">
              <h4 className="font-bold text-sm text-emerald-950">
                {lang === "bn" ? "\u09E7. \u09AC\u09BE\u09DF\u09A4\u09C1\u09B2 \u09AE\u09C1\u0995\u09BE\u09A6\u09CD\u09A6\u09BE\u09B8 \u099C\u09BE\u09AE\u09C7 \u09AE\u09B8\u099C\u09BF\u09A6" : "1. Baitul Muqaddas Jame Masjid"}
              </h4>
              <p className="text-xs text-slate-600 leading-relaxed">
                {lang === "bn" ? "\u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8 \u09AA\u09CD\u09B0\u09BE\u0999\u09CD\u0997\u09A3\u09C7\u0987 \u09B8\u09C1\u0989\u099A\u09CD\u099A \u09AE\u09BF\u09A8\u09BE\u09B0\u09AC\u09BF\u09B6\u09BF\u09B7\u09CD\u099F \u099C\u09BE\u09AE\u09C7 \u09AE\u09B8\u099C\u09BF\u09A6, \u09AF\u09C7\u0996\u09BE\u09A8\u09C7 \u099B\u09BE\u09A4\u09CD\u09B0\u09B0\u09BE \u09EB \u0993\u09DF\u09BE\u0995\u09CD\u09A4 \u09A8\u09BE\u09AE\u09BE\u099C \u099C\u09BE\u09AE\u09BE\u09A4\u09C7 \u0986\u09A6\u09BE\u09AF\u09BC \u0995\u09B0\u09C7\u0964" : "Spacious on-campus masjid with minaret for daily congregation prayers and practical Islamic training."}
              </p>
            </div>

            <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200/80 space-y-2">
              <h4 className="font-bold text-sm text-emerald-950">
                {lang === "bn" ? "\u09E8. \u0989\u09A8\u09CD\u09AE\u09C1\u0995\u09CD\u09A4 \u0996\u09BF\u09B2\u09BE\u09A8\u09AF\u09C1\u0995\u09CD\u09A4 \u0995\u09CD\u09B2\u09BE\u09B8\u09B0\u09C1\u09AE" : "2. Arched Sunlit Classrooms"}
              </h4>
              <p className="text-xs text-slate-600 leading-relaxed">
                {lang === "bn" ? "\u09AA\u09CD\u09B0\u09BE\u0995\u09C3\u09A4\u09BF\u0995 \u0986\u09B2\u09CB \u0993 \u09B8\u09C1\u09AC\u09BE\u09A4\u09BE\u09B8\u09AF\u09C1\u0995\u09CD\u09A4 \u09AA\u09CD\u09B0\u09B6\u09B8\u09CD\u09A4 \u0995\u0995\u09CD\u09B7, \u0989\u09A8\u09CD\u09A8\u09A4 \u09AC\u09B8\u09BE\u09B0 \u09A1\u09C7\u09B8\u09CD\u0995 \u098F\u09AC\u0982 \u099A\u0995-\u09B8\u09CD\u09B2\u09C7\u099F\u09C7\u09B0 \u0986\u09A7\u09C1\u09A8\u09BF\u0995 \u09AC\u09CD\u09AF\u09AC\u09B8\u09CD\u09A5\u09BE\u0964" : "Naturally ventilated arched verandas, comfortable wooden desks, and individual blackboard spaces."}
              </p>
            </div>

            <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200/80 space-y-2">
              <h4 className="font-bold text-sm text-emerald-950">
                {lang === "bn" ? "\u09E9. \u09B8\u09C1\u09AA\u09C7\u09AF\u09BC \u09AA\u09BE\u09A8\u09BF \u0993 \u09B8\u09CD\u09AC\u09BE\u09B8\u09CD\u09A5\u09CD\u09AF\u09AC\u09BF\u09A7\u09BF" : "3. Pure Safe Drinking Water"}
              </h4>
              <p className="text-xs text-slate-600 leading-relaxed">
                {lang === "bn" ? "\u0986\u09B0\u09CD\u09B8\u09C7\u09A8\u09BF\u0995\u09AE\u09C1\u0995\u09CD\u09A4 \u0997\u09AD\u09C0\u09B0 \u09A8\u09B2\u0995\u09C2\u09AA\u09C7\u09B0 \u09AC\u09BF\u09B6\u09C1\u09A6\u09CD\u09A7 \u09AA\u09BE\u09A8\u09BF, \u09AA\u09B0\u09BF\u099A\u09CD\u099B\u09A8\u09CD\u09A8 \u0993\u099C\u09C1 \u0993 \u09B8\u09CD\u09AC\u09BE\u09B8\u09CD\u09A5\u09CD\u09AF\u09B8\u09AE\u09CD\u09AE\u09A4 \u0993\u09DF\u09BE\u09B6\u09B0\u09C1\u09AE \u09AC\u09CD\u09AF\u09AC\u09B8\u09CD\u09A5\u09BE\u0964" : "Deep tube-well filtered safe water, pristine wudu areas, and strictly sanitized premises."}
              </p>
            </div>

            <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200/80 space-y-2">
              <h4 className="font-bold text-sm text-emerald-950">
                {lang === "bn" ? "\u09EA. \u09A8\u09BF\u09B0\u09BE\u09AA\u09A6 \u0986\u09AC\u09BE\u09B8\u09A8 \u0993 \u09B9\u09CB\u09B8\u09CD\u099F\u09C7\u09B2" : "4. Residential Hifz Boarding"}
              </h4>
              <p className="text-xs text-slate-600 leading-relaxed">
                {lang === "bn" ? "\u09B9\u09BF\u09AB\u099C \u09AC\u09BF\u09AD\u09BE\u0997\u09C7\u09B0 \u099B\u09BE\u09A4\u09CD\u09B0\u09A6\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u09B8\u09BE\u09B0\u09CD\u09AC\u0995\u09CD\u09B7\u09A3\u09BF\u0995 \u09B6\u09BF\u0995\u09CD\u09B7\u0995\u09C7\u09B0 \u09A8\u099C\u09B0\u09A6\u09BE\u09B0\u09BF, \u09AA\u09C1\u09B7\u09CD\u099F\u09BF\u0995\u09B0 \u0996\u09BE\u09AC\u09BE\u09B0 \u098F\u09AC\u0982 \u09B8\u09C1\u09B8\u09CD\u09A5 \u09AC\u09BF\u09A8\u09CB\u09A6\u09A8\u0964" : "Disciplined boarding quarters under Ustadh guardianship with nutritious home-cooked meals."}
              </p>
            </div>
          </div>
        </div>
      </div>

      {
    /* ------------------------------------------------------------- */
  }
      {
    /* 6. CALL TO ACTION                                             */
  }
      {
    /* ------------------------------------------------------------- */
  }
      <div className="max-w-4xl mx-auto px-4 text-center space-y-4">
        <h3 className="text-2xl font-bold font-serif text-slate-900">
          {lang === "bn" ? "\u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8\u09C7 \u098F\u09B8\u09C7 \u09B8\u09B0\u09BE\u09B8\u09B0\u09BF \u0998\u09C1\u09B0\u09C7 \u09AF\u09BE\u09A8" : "Experience Our Campus in Person"}
        </h3>
        <p className="text-xs sm:text-sm text-slate-600 max-w-xl mx-auto">
          {lang === "bn" ? "\u09A4\u09C1\u09B2\u09BE\u09A4\u09B2\u09C0 \u09AC\u09BE\u099C\u09BE\u09B0 \u09B8\u0982\u09B2\u0997\u09CD\u09A8 \u0986\u09AE\u09BE\u09A6\u09C7\u09B0 \u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8\u09C7 \u0986\u09AA\u09A8\u09BF \u09B8\u09AA\u09B0\u09BF\u09AC\u09BE\u09B0\u09C7 \u0986\u09AE\u09A8\u09CD\u09A4\u09CD\u09B0\u09BF\u09A4\u0964 \u0986\u09AE\u09BE\u09A6\u09C7\u09B0 \u09B8\u09AE\u09CD\u09AE\u09BE\u09A8\u09BF\u09A4 \u09B6\u09BF\u0995\u09CD\u09B7\u0995\u09A6\u09C7\u09B0 \u09B8\u09BE\u09A5\u09C7 \u09B8\u09B0\u09BE\u09B8\u09B0\u09BF \u0995\u09A5\u09BE \u09AC\u09B2\u09C1\u09A8\u0964" : "We welcome you to visit our campus at Tulatoli Bazar, Daganbhuiyan, Feni and meet our faculty."}
        </p>
        <div className="pt-2">
          <button
    onClick={() => onNavigate("contact")}
    className="px-6 py-3 text-xs font-bold text-white bg-emerald-800 hover:bg-emerald-900 rounded-xl shadow-md cursor-pointer transition-all inline-flex items-center gap-2"
  >
            <MapPin className="w-4 h-4 text-amber-400" />
            <span>{lang === "bn" ? "\u09AF\u09CB\u0997\u09BE\u09AF\u09CB\u0997 \u0993 \u0995\u09CD\u09AF\u09BE\u09AE\u09CD\u09AA\u09BE\u09B8 \u09A6\u09BF\u0995\u09A8\u09BF\u09B0\u09CD\u09A6\u09C7\u09B6\u09A8\u09BE" : "Contact Us & Campus Directions"}</span>
          </button>
        </div>
      </div>
    </div>;
};
